import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Chip, TableCell, TableRow } from '@mui/material'

import {
  TableMenuButtonComponent,
  TableMenuComponent,
  TableMenuOptions,
} from '@/views'
import { useUsers } from '@/views/users/hooks/use-users.hook'
import { UserLibraryColumnProps } from '@/state/user/models'

type Props = {
  row: UserLibraryColumnProps
}

export const UsersRowComponent = ({ row }: Props) => {
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const { userSession, handleDeleteUser, handleEditUser } = useUsers()

  const canDelete = userSession?.id !== row?.id

  const handleClickButton = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    type: TableMenuOptions,
  ) => {
    const anchorPosition = {
      top: anchorEl?.getBoundingClientRect().top || event.clientY,
      left: anchorEl?.getBoundingClientRect().left || event.clientX,
    }
    type === 'delete' && handleDeleteUser(anchorPosition, row.id)
    type === 'edit' && handleEditUser(row)

    setAnchorEl(null)
  }

  const getRoleName = (roleId: number) => {
    switch (roleId) {
      case 1:
        return 'roleType.SUPER_ADMIN'

      case 2:
        return 'roleType.AGENT'

      case 3:
        return 'roleType.MANAGER'

      default:
        return '-'
    }
  }

  return (
    <>
      <TableRow hover>
        <TableCell sx={{ width: '118px' }}>
          <Chip
            variant="filled"
            size="medium"
            label={t(`${row.isActive ? 'labels.active' : 'labels.inactive'}`)}
            className={`${row.isActive ? 'green' : 'red'}`}
            sx={{ width: '118px' }}
          />
        </TableCell>
        <TableCell>{`${row.firstName} ${row.lastName}`}</TableCell>
        <TableCell>{row.email}</TableCell>
        <TableCell>{row.username}</TableCell>
        <TableCell>{t(`${getRoleName(row.role)}`)}</TableCell>
        <TableMenuButtonComponent setAnchorEl={setAnchorEl} />
      </TableRow>
      <TableMenuComponent
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        handleClickButton={handleClickButton}
        canDelete={canDelete}
        canEdit
      />
    </>
  )
}
